module.exports = __webpack_public_path__ + "img/learning-analytics.6aec8b4.webp";